import { ENV } from "../../Utils/constants";
import { cabecerasApi } from "./cabeceras";

export class ReviTherapyApi {
  constructor() {
    this.baseApi = ENV.BASE_API;
  }

  /**
   * Obtiene las terapias creadas (Dashboard sidebar).
   * Ruta: [BASE_API]/therapy
   */
  async getTherapies(token, { page = 1, limit = 10, visibility = "all" } = {}) {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      visibility: visibility,
    });

    const url = `${this.baseApi}/${ENV.API_ROUTES.THERAPY}?${params.toString()}`;

    const res = await fetch(url, {
      headers: cabecerasApi(token),
    });

    const json = await res.json();
    if (res.status !== 200) throw new Error(json.message);

    return {
      therapies: json.therapies,
      pagination: json.pagination,
    };
  }

  /**
   * Obtiene TODAS las terapias de una institución (Panel Institucional)
   * Endpoint: GET /revi/therapy/institution/:institutionId
   */
  async getByInstitution(
    token,
    institutionId,
    { page = 1, limit = 12, search = "" } = {},
  ) {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });

    if (search) params.append("search", search);

    const url = `${this.baseApi}/revi/therapy/institution/${institutionId}?${params.toString()}`;

    const res = await fetch(url, {
      headers: cabecerasApi(token),
    });

    const json = await res.json();
    if (res.status !== 200) throw new Error(json.message);

    return {
      therapies: json.therapies,
      pagination: json.pagination,
    };
  }

  /**
   * ✅ Detalle de terapia (para el modal "Ver detalle")
   * Endpoint: GET /revi/therapy/:therapyId
   */
  async getById(token, therapyId) {
    const url = `${this.baseApi}/revi/therapy/${therapyId}`;

    const res = await fetch(url, {
      method: "GET",
      headers: { ...cabecerasApi(token), "Content-Type": "application/json" },
    });

    const json = await res.json();
    if (res.status !== 200) {
      throw new Error(json.message || "Error al obtener la terapia");
    }

    return json; // { code, message, therapy }
  }

  /**
   * ✅ Alias seguro (no rompe nada): devuelve directamente la terapia
   * Útil si algún módulo espera getTherapyById().
   */
  async getTherapyById(token, therapyId) {
    const json = await this.getById(token, therapyId);
    return json?.therapy || json;
  }

  /**
   * ✅ Subir una sala (scene-step) una posición (swap con la anterior)
   * Endpoint: PATCH /revi/therapy/:therapyId/scene/:therapySceneId/move-up
   */
  async moveSceneUp(token, therapyId, therapySceneId) {
    const url = `${this.baseApi}/revi/therapy/${therapyId}/scene/${therapySceneId}/move-up`;

    const res = await fetch(url, {
      method: "PATCH",
      headers: { ...cabecerasApi(token), "Content-Type": "application/json" },
    });

    const json = await res.json();
    if (res.status !== 200) {
      throw new Error(json.message || "Error al reordenar la sala");
    }

    return json;
  }
}
